import "./heroMain.scss";
import Arrow from "../SVG/ArrowSvg";
import Sanne from "../../Images/png/Sanne.png";
import HeroVect1 from "../SVG/HeroVec1";
import HeroVec2 from "../SVG/HeroVec2";
import Circle from "../SVG/Circle";

const HeroMain = () => {
  return (
    <section className="heroMain">
      <div className="left">
        <div className="text-container">
          <div className="title">
            Communicatie &nbsp;
            <span className="circle-text">
              en &nbsp;
              <div className="circle">
                <Circle />
              </div>
            </span>
            persoonlijke ontwikkeling
          </div>
          <p className="subText">Trainingen</p>
          <a
            target="_blank"
            href="https://www.bol.com/nl/nl/p/gedachten-zijn-klootzakken/9300000166623295/?bltgh=g6wvBF0pwoGa4wpkbyRAOw.2_14.15.ProductPageUrl"
            rel="noreferrer"
            className="button"
          >
            <Arrow className="arrow" />
            <p className="text-button">Koop hier mijn nieuwste boek</p>
          </a>
          <p className="download-text">
            De bestanden ter ondersteuning van het boek download je hier.
          </p>
          <div className="download-container">
            <a
              className="button-file"
              href="ChecklistTienIngredienten.pdf"
              download
            >
              <Arrow className="arrow" />
              <p className="text-button">checklist voor een anti-aanbakbrein</p>
            </a>
            <a
              href="SchuldgevoelStroomschema.pdf"
              download
              className="button-file"
            >
              <Arrow className="arrow" />
              <p className="text-button">stroomschema schuldgevoel</p>
            </a>
          </div>
        </div>
      </div>
      <div className="right">
        <div className="absolute-container">
          <HeroVect1 />
        </div>
        <div className="absolute-container">
          <HeroVec2 />
        </div>
        <div className="img-container">
          <img src={Sanne} alt="Sanne" />
        </div>
      </div>
    </section>
  );
};

export default HeroMain;
